import React from "react";
import { useI18n } from "@/lib/i18n";
import TermsOfServiceEn from "@/pages/TermsOfServiceEn";
import TermsOfServiceId from "@/pages/TermsOfServiceId";

export default function TermsOfService() {
  const { lang } = useI18n();
  return lang === "en" ? <TermsOfServiceEn /> : <TermsOfServiceId />;
}
